var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"twemojiTextarea",class:_vm.$attrs.class,attrs:{"id":"emojies"}})
}
var staticRenderFns = []

export { render, staticRenderFns }